const ANOMALY_PROMPT = /^Investigate this analytics anomaly\b/i;
const PERIOD = /^Period \(UTC, inclusive\): (\d{4}-\d{2}-\d{2}) to (\d{4}-\d{2}-\d{2})$/m;
const METRIC = /^Metric: "([^"]+)"$/m;
const DIRECTION = /^Direction: (spike|drop)$/m;
const EVIDENCE = /^Evidence:\s*$/im;
const CONFIDENCE = /^\*\*Confidence:\*\*\s*(.+)$/im;

const shortDate = (value: string): string =>
  new Intl.DateTimeFormat(undefined, {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(`${value}T00:00:00.000Z`));

export const isGeneratedAnomalyPrompt = (text: string): boolean =>
  ANOMALY_PROMPT.test(text.trim());

export const assistantUserMessageLabel = (text: string): string => {
  if (!isGeneratedAnomalyPrompt(text)) {
    return text;
  }
  const metric = text.match(METRIC)?.[1] ?? 'metric';
  const direction = text.match(DIRECTION)?.[1] ?? 'change';
  const period = text.match(PERIOD);
  if (!period) {
    return `Explain ${metric} ${direction}`;
  }
  const from = shortDate(period[1]);
  const to = shortDate(period[2]);
  return `Explain ${metric} ${direction} · ${from === to ? from : `${from}–${to}`}`;
};

export type AnomalyAnswerSections = {
  conclusion: string;
  confidence: string | null;
  evidence: string | null;
};

export const anomalyAnswerSections = (
  text: string,
): AnomalyAnswerSections => {
  const evidenceMatch = EVIDENCE.exec(text);
  const beforeEvidence = evidenceMatch
    ? text.slice(0, evidenceMatch.index).trim()
    : text.trim();
  const evidence = evidenceMatch
    ? text.slice(evidenceMatch.index + evidenceMatch[0].length).trim() || null
    : null;
  const confidenceMatch = CONFIDENCE.exec(beforeEvidence);
  const confidence = confidenceMatch?.[1]?.trim() ?? null;
  const conclusion = confidenceMatch
    ? `${beforeEvidence.slice(0, confidenceMatch.index)}${beforeEvidence.slice(confidenceMatch.index + confidenceMatch[0].length)}`.trim()
    : beforeEvidence;
  return { conclusion, confidence, evidence };
};
